import { Button, Container, Row, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../stores/hooks";
import { getContestRoundGameDetailAsync, ContestRoundGameState } from "../ContestRoundGameSlice";
import { Formik } from "formik";
import { ContestRoundGameDetailInterface } from "../models/ContestRoundGameDetailInterface";
import ModuleConfig from "../config/ModuleConfig";
import FormField from "../../common/FormField";
import { useEffect } from "react";
import { createContestRoundGame, updateContestRoundGame } from "../ContestRoundGameAPI";

/**
 * ContestRoundGameing Favourites list page
 */
const ContestRoundGameCreate = () => {
  const dispatch = useAppDispatch();
  const { status, detail } = useAppSelector(ContestRoundGameState);
  const params = useParams();
  const navigator = useNavigate();

  useEffect(() => {
    if (params.game_id) {
      dispatch(getContestRoundGameDetailAsync(params.game_id)); 
    }
  }, [params.game_id]);

  const handleSubmit = async (values: ContestRoundGameDetailInterface, formMethod: any) => {
    if (params.game_id) {
      values.contest_round_id = params.contest_round_id
      const res: any = await updateContestRoundGame(params.game_id, values);
      if (res.errors && res.message) {
        const errors: any = {};
        const errorKeys = Object.keys(res.errors);
        for (var i = 0; i < errorKeys.length; i++) {
          errors[errorKeys[i]] = res.errors[errorKeys[i]][0];
        }
        formMethod.setErrors(errors);
      } else {
        navigator(`/contest-round-game/${params.contest_id}/${params.contest_round_id}`);
      }
    } else {
      values.contest_round_id = params.contest_round_id
      const res: any = await createContestRoundGame(values);
      if (res.errors && res.message) {
        const errors: any = {};
        const errorKeys = Object.keys(res.errors);
        for (var i = 0; i < errorKeys.length; i++) {
          errors[errorKeys[i]] = res.errors[errorKeys[i]][0];
        }
        formMethod.setErrors(errors);
      } else {
        navigator(`/contest-round-game/${params.contest_id}/${params.contest_round_id}`);
      }
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title">
                <h5 className="m-b-10">Contest Round Game</h5>
              </div>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="feather icon-home"></i>
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/contest-round-game/${params.contest_id}/${params.contest_round_id}`}>Contest Round Games</Link>
                </li>
                <li className="breadcrumb-item">
                  <a>{params.game_id ? "Edit " : "Add "}Contest Round Game</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header">
              <h5>{params.game_id ? "Edit " : "Add "}Contest Round Game</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <Formik
                    initialValues={
                      detail[ModuleConfig.primaryKey] == params.game_id
                        ? detail
                        : ModuleConfig.formDefaultValue
                    }
                    validate={(values) => {
                      const errors: any = {};
                      const fields = Object.keys(ModuleConfig.formFields);
                      for (let index = 0; index < fields.length; index++) {
                        if (
                          !values[fields[index]] &&
                          ModuleConfig.formFields[fields[index]].isRequired
                        ) {
                          errors[fields[index]] = "Required";
                        }
                      }
                      if(values['team1_id'] == values['team2_id']){
                        errors['team1_id'] = "You can not select same teams";
                        errors['team2_id'] = "You can not select same teams";
                      }
                      return errors;
                    }}
                    enableReinitialize={true}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          {Object.keys(ModuleConfig.formFields).map(
                            (field: string, index: number) => {
                              const fieldDetails =
                                ModuleConfig.formFields[field];
                              return (fieldDetails.isAdd == false &&
                                params.game_id) ||
                                fieldDetails.isAdd == undefined ? (
                                <div
                                  key={`field_${index}`}
                                  className={fieldDetails.colWidth}
                                >
                                  <FormField
                                    name={field}
                                    fieldDetails={fieldDetails}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    filterParams={`contest_id=${params.contest_id}`}
                                    setFieldValue={setFieldValue}
                                    handleChange={handleChange}
                                    handleBlur={handleBlur}
                                  />
                                </div>
                              ) : null;
                            }
                          )}
                        </div>
                        <hr />
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={status === "loading"}
                        >
                          Submit
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContestRoundGameCreate;
